import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
import type { BreadcrumbItem } from '../../types/storage';

interface FileBreadcrumbProps {
  breadcrumbs: BreadcrumbItem[];
  onNavigate: (index: number) => void;
}

export default function FileBreadcrumb({ breadcrumbs, onNavigate }: FileBreadcrumbProps) {
  return (
    <nav aria-label="File path" className="flex items-center gap-1 flex-wrap">
      {breadcrumbs.map((crumb, i) => {
        const isLast = i === breadcrumbs.length - 1;
        return (
          <React.Fragment key={crumb.id}>
            {i === 0 ? (
              <button
                onClick={() => onNavigate(0)}
                className={`flex items-center gap-1 text-sm rounded px-1.5 py-0.5 transition-colors ${
                  isLast
                    ? 'text-gray-900 font-medium cursor-default'
                    : 'text-indigo-600 hover:bg-indigo-50'
                }`}
                disabled={isLast}
              >
                <Home className="w-3.5 h-3.5" />
                <span>{crumb.name}</span>
              </button>
            ) : (
              <button
                onClick={() => onNavigate(i)}
                className={`text-sm rounded px-1.5 py-0.5 transition-colors ${
                  isLast
                    ? 'text-gray-900 font-medium cursor-default'
                    : 'text-indigo-600 hover:bg-indigo-50'
                }`}
                disabled={isLast}
              >
                {crumb.name}
              </button>
            )}
            {!isLast && <ChevronRight className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
